
//==================
function getCurrentPageFromURL() {
  const trigger = document.getElementById("infinite-scroll-trigger");
  return parseInt(trigger.getAttribute("data-current-page")) || 1;
}

function getTotalPages(trigger) {
  return parseInt(trigger.getAttribute("data-total-pages")) || 1;
}
async function loadMoreProducts() {
  const trigger = document.getElementById("infinite-scroll-trigger");
  const productsGrid = document.querySelector("#product-grid");
  const sectionId = trigger.getAttribute("data-section-id");
  let currentPage = getCurrentPageFromURL();
  const totalPages = getTotalPages(trigger);

  if (currentPage >= totalPages) return;

  currentPage++;
  trigger.setAttribute("data-current-page", currentPage);

  const url = new URL(window.location.href);
  url.searchParams.set("page", currentPage);
  if (sectionId) url.searchParams.set("section_id", sectionId);

  const browserUrl = new URL(window.location.href);
  browserUrl.searchParams.set("page", currentPage);
  window.history.replaceState({}, "", browserUrl.toString());
  trigger.classList.add("is-loading");

  try {
    const response = await fetch(url);
    if (!response.ok) throw new Error("Network error");

    const text = await response.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(text, "text/html");
    const newContent = doc.querySelector("#product-grid");

    if (newContent) {
      Array.from(newContent.children).forEach((el) => {
        productsGrid.appendChild(el);
      });
    }
  } catch (err) {
    console.error("Failed to load more products", err);
  } finally {
    setTimeout(() => {
      trigger.classList.remove("is-loading");
    }, 300);
  }
}

 window.setupInfiniteScroll = function() {
  const trigger = document.getElementById("infinite-scroll-trigger");
  if (!trigger) return;
  console.log('reloaded')
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          loadMoreProducts();
        }
      });
    },
    { threshold: 1 }
  );

  observer.observe(trigger);
}

document.addEventListener("DOMContentLoaded", () => {
  window.setupInfiniteScroll();
});